export default "__VITE_ASSET__DCmYvg$t__"